import Module, { moduleInit } from "../../../../framework/core/mvvm/module_base";
import { TexasPokerView } from "./texas_poker_view";
import { TexasPokerModel } from "./texas_poker_model";
import GameServer from "../../../hall/server/gameserver/game_server";
import { Define } from "./data/const_define";
import ModuleManager from "../../../../framework/core/module_manager";
import { TableData } from "./data/table_data";
import TexasSound from "../texas_sound";
import { TableEntityBase } from "./base/table/table_entity_base";
import { TableEntityViewModel } from "./base/table/table_view_model";
import Setting from "../../../hall/module/setting/setting";
import DialogTips from "../../../public/module/dialog_tips/dialog_tips";
import Record from "../../../hall/module/record/record";
import { TableHelp } from "./help/table_help";
import LanguageManager from "../../../../manager/language_manager";
import GameMorePanel from "../../../table/module/game_morepanel/game_morepanel";
import DialogLeave from "../../../public/module/dialog_leave/dialog_leave";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("TexasPokerTable")
export default class TexasPokerTable extends Module<TexasPokerView,TexasPokerModel> {

    //当前牌桌
    private tableEntity:TableEntityBase;

    constructor(){
        super();
        this.windowPrefabResPath = 'package/texasholdem/module/table/texasholdem_table';
        this.viewType = TexasPokerView;
        this.modelType = TexasPokerModel;
    }

    onInit(){
        this.createTable();
        this.registerUiEvent();
    }

    onShow(){
        this.model.init(GameServer.instance.netClient)
        this.model.clearMsgEvent()
        this.tableEntity.initNetMessage(this);
        TexasSound.playBg();


    }

    //创建牌桌
    createTable(){
        this.tableEntity = new TableEntityViewModel();
        this.tableEntity.create();
        this.tableEntity.createTableView(this.view.gameRoot,this.view.talePrefab);
    }

    registerUiEvent(){
        this.view.maskEvent.on('click',this.maskEvent,this);

        this.tableEntity.on(Define.refreshUI,this.updateBtnShow,this);

        this.tableEntity.on(Define.updateUI,this.updateUI,this);

        this.view.slider.on('slide', this.sliderCallBack, this);
        this.eventBind("event_exit_game",()=>{
            this.showTipsAccordPlayer(LanguageManager.t('dz_game_autoexit'),()=>{
                this.tableEntity.ReqPlayerAction(Define.SeatAction.Leave)
            })
        }); //绑定退出事件
    }

    protected onButtonClick(node: cc.Node, customEventData){
        let pName = node.parent.name;
        switch (pName) {
            case 'LeftButton':
                this.clickLeftShowBtn();
                break;
            case 'NoRound':
                this.clickAutoBtn(node);
                break;
            case 'GameIn':
                this.clickOperator(node);
                break;
            case 'Operator_bg':
                this.raseCallBack(node);
                break;
            case 'Bg':
                this.clickLeftOpBtn(node);
                break;
            case 'decrease':
                this.decreaseBet();
                break;
            case 'addbet':
                this.addMinBet();
                break;
            case 'test':
                this.model.disconnect();
                break;
            default:
                break;
        }
    }

    //增加一个盲注
    addMinBet(){
        let progress = this.view.sliderProgress.progress
        let count = this.getProgressCount(progress);
        if (progress <= 1) {
            count++;
            let rase = this.min+this.tableEntity.boardData.bigBlind*count;
            let addProgress = this.minProgress + this.mindelta*count
            if (addProgress == 1) {
                this.raseNum = this.max;
                this.view.updateSliderUI(1,this.max);
            }else if(addProgress < 1){
                this.raseNum = rase;
                this.view.updateSliderUI(addProgress,rase);
            }
        }
    }

    //减少一个盲注
    decreaseBet(){
        let progress = this.view.sliderProgress.progress
        let count = this.getProgressCount(progress);
        if (progress >= this.minProgress) {
            count--;
            let rase = this.min+this.tableEntity.boardData.bigBlind*count;
            let decrease = this.minProgress + this.mindelta*count
            if (decrease > this.minProgress) {
                this.raseNum = rase;
                this.view.updateSliderUI(decrease,rase); 
            }else if (decrease == this.minProgress) {
                this.raseNum = this.min;
                this.view.updateSliderUI(this.minProgress,rase); 
            }
        }
    }

    //mask event
    maskEvent(){
        this.view.clickMask();
        this.raseNum = 0;
    }
    private actionData:TableData.IActionData;
    updateBtnShow(v:any){
        let data = <TableData.Setting>v;
        if (data) {
            if (data.isMyRound) {
                this.hideAllWindow();
            }
            this.actionData = data.actionData;
        }
        this.raseNum =0;//重置
        this.view.setMySelfOperator(data);
    }

    //隐藏所有窗口
    private hideAllWindow(){
        this.view.clickMask();
        ModuleManager.instance.hideModule('Record')
        ModuleManager.instance.hideModule('GameMorePanel')
        ModuleManager.instance.hideModule('TexasChips')
    }

    private min:number;
    private max:number;
    private minProgress:number;
    private mindelta:number;


    private getProgressCount(progress:number){
        let count = 0;
        while (progress <= 1) {
            if (progress <= this.minProgress + this.mindelta*count) {
                break;
            }else{
                count++;
            }
        }
        return count;
    }

    sliderCallBack(slider:cc.Slider){

        if (slider.progress < this.minProgress) {//最小加注
            this.view.updateSliderUI(this.minProgress,this.min);
            this.raseNum = this.min;
            return;
        }

        if (slider.progress == 1) {
            this.raseNum = this.max;
            this.view.updateSliderUI(1,0);
        }else{
            let count = this.getProgressCount(slider.progress);
            if (count > 0) {
                let rase = this.min+this.tableEntity.boardData.bigBlind*count;
                this.view.updateSliderUI(this.minProgress + this.mindelta*count,rase);
                this.raseNum = rase;
            }
        }
    }

    showTipsAccordPlayer(str:string,func:Function){
        let data = this.tableEntity.getPlayerSeatData();
        //all-in状态特殊处理
        if (data && data.state == Define.PlayerState.All_in) {
            ModuleManager.instance.showModule(DialogLeave)
            // let text = LanguageManager.t("public_cannotLeave", true);
            // ModuleManager.instance.showModuleName("Toast",{text : text,long : true});
            return;
        }
        if (!data
            || data.state == Define.PlayerState.Look_1
            || data.state == Define.PlayerState.Look_2
            || data.state == Define.PlayerState.GiveUp) {
                if (func) {
                    func();
                }
        }else{
            let leaveCallFunc = ()=>{
                if (func) {
                    func();
                }
            }
            ModuleManager.instance.showModule(DialogLeave)
           // ModuleManager.instance.showModule(DialogTips, { Content: str,EnterCallBack:leaveCallFunc })
        }
    }

    clickLeftOpBtn(btn:cc.Node){
        let index = parseInt(btn.name);
        if (index == 0) {
            this.showTipsAccordPlayer(LanguageManager.t('dz_game_autoexit'),()=>{
                this.tableEntity.ReqPlayerAction(Define.SeatAction.Leave)
            })
        }else if(index == 1){
            // this.showTipsAccordPlayer(LanguageManager.t('dz_standautoexit'),()=>{
            //     this.tableEntity.ReqPlayerAction(Define.SeatAction.Stand)
            // })
        }else if(index == 2){
            cc.log('记录');
            //this.tableEntity.ww();
            ModuleManager.instance.showModule(Record, "record")
        }else{
            cc.log('设置');
            //cc.log('--------->>>rr',this.raseNum);
            //this.tableEntity.gggg();
            ModuleManager.instance.showModule(Setting);
        }
    }

    clickAutoBtn(btn:cc.Node){
        let index = parseInt(btn.name);
        let autoData = this.tableEntity.settingData;
        let data = {1:TableData.AutoSetting.Chek_Pass,2:TableData.AutoSetting.Auto_Check,3:TableData.AutoSetting.Any_Call};
        if (data[index]) {
            this.tableEntity.setAutoSetting(data[index])
            this.view.showEffect(index-1,autoData.autoCheck == data[index]);
        }
    }

    updateUI(data:any){
        this.view.updateRoundNo(data);
    }

    raseCallBack(btn:cc.Node){
        let index = parseInt(btn.name);
        let bet = this.tableEntity.boardData.pot;
        let betTab = {1:1,2:(2/3),3:0.5,}
        let v = (betTab[index] * bet);
        if (v) {
            this.tableEntity.ReqPlayerOperator(Define.Operator.Raise,v);
        }else{
            this.tableEntity.ReqPlayerOperator(Define.Operator.All_in);
        }
        this.view.allInUI = false;
    }


    getSeatNodeById(playerId: number):cc.Node{
        if (this.tableEntity) {
            let entity = this.tableEntity.getEntityByPlayerID(playerId);
            let seatNode = entity.getSeatNode();
            return seatNode;
        }
        return null;
    }

    clickLeftShowBtn(){
        ModuleManager.instance.showModule(GameMorePanel);
    }

    private raseNum:number=0;//加注金额
    clickOperator(btn:cc.Node){
        let index = parseInt(btn.name);
        let data = {3:Define.Operator.GiveUp,2:Define.Operator.Fold_Check,1:Define.Operator.Raise,4:Define.Operator.All_in};
        if (data[index]) {
            if (index == 1) {
                let e = this.actionData;
                if (e && e != undefined) {
                    this.view.allInState(this.tableEntity.boardData.pot,this.tableEntity.settingData);

                    this.min = (e.min);
                    this.max = (e.max);

                    if (this.max <= 0 || this.tableEntity.boardData.bigBlind == 0) {
                        return;
                    }
                    if (this.min >= this.max) {
                        this.min = this.max;
                    }
                    this.minProgress = this.min / this.max;
                    this.mindelta = (1-this.minProgress) /  ((this.max-this.min) / this.tableEntity.boardData.bigBlind);
                    let min = TableHelp.getRightMount(this.min);
                    this.view.sliderProgress.progress = this.minProgress;
                    this.view.slider.getComponent(cc.ProgressBar).progress = this.minProgress;
                    this.view.updateMaskSize(this.minProgress);
                    this.view.updateSliderUI(this.minProgress,min,false);
                    if (this.raseNum > 0) {//加注
                        if (this.raseNum >= this.max) {
                            this.tableEntity.ReqPlayerOperator(Define.Operator.All_in);
                        }else{
                            this.tableEntity.ReqPlayerOperator(Define.Operator.Raise,this.raseNum);
                        }
                       this.raseNum = 0;//加注重置位零
                    }else{
                       this.raseNum = min;
                    }
                }
            }else{
                this.tableEntity.ReqPlayerOperator(data[index]);
            }
            if (index != 1) {
                this.view.allInUI = false;
            }
        }
    }

    onHide(){
        if (this.tableEntity != undefined) {
            this.tableEntity.clear();
        }
    }

    on_destroy(){
        if (this.tableEntity != undefined) {
            this.tableEntity.clear();
        }
        cc.log('-->>>>离开牌桌')
    }

}
